import { styled } from '@metrika/ui-kit/emotion';

export const CenterTopFixed = styled.div`
   position: fixed;
   left: calc(50% + 24px);

   top: 14px;

   z-index: ${({ theme }) => theme.zIndex.absoluteTop};

   svg {
      fill: white;
      cursor: pointer;
      &:hover {
         fill: ${({ theme }) => theme.colors.interactive01};
      }
   }
`;

export const DebugMainPanelWrapper = styled.div`
   background: ${({ theme }) => theme.colors.backgroundHover};
   min-height: 100vh;
   ${({ theme }) => theme.typo.code01}
   color: ${({ theme }) => theme.colors.text01};
   p {
      padding: 0 0.5rem;
      width: 100%;
      text-align: center;
      font-size: 1rem;
      font-weight: bold;
      color: ${({ theme }) => theme.colors.text01};
      margin-top: 1rem;
   }

   .cds--form-item.cds--checkbox-wrapper {
      margin: 0;
   }

   h5,
   label {
      font-size: 0.75rem;
      align-items: center;
      padding-top: 0;
   }

   display: flex;
   flex-direction: column;

   & > div {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.5rem;

      & > div {
         margin-right: 1rem;
         display: flex;
         flex-direction: column;
      }
   }

   .debugPersist {
      color: ${({ theme }) => theme.colors.textPrimary};
      font-weight:;
   }
`;
